import { SVGProps } from 'react'

export const LogonSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version='1.1'
      viewBox='0 0 1024 1024'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M171.2 459.2V173.6h684v408H293.6l115.2 115.2h45.6v45.6L584 872h98.4v-117.6h-112.8v-57.6H968V56H56v288z' />
    </svg>
  )
}
